import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';
import { BadgeVariant, BadgeColorVariant } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CBadge',
  props: {
    variant: { default: 'light' },
    color: { default: 'default' },
    text: null,
    pill: { type: Boolean },
    itemStyle: { default: '' }
  },
  setup(__props: any) {

const props = __props as { variant: BadgeVariant, color: BadgeColorVariant, text?: string, pill?: boolean, itemStyle: string };



const slots = useSlots();

const typeClasses = computed(() => {
    const types: Record<BadgeVariant, Record<string, Record<string, string>>> = {
        ['outline']: {
            // TODO: configurations for outline badges
        },
        ['light']: {
            yellow: {
                bg: 'bg-yellow-lighter',
                color: 'color-yellow-dark'
            },
            blue: {
                bg: 'bg-blue-lighter',
                color: 'color-blue'
            },
            orange: {
                bg: 'bg-orange-lighter',
                color: 'color-orange'
            },
            purple: {
                bg: 'bg-purple-lighter',
                color: 'color-purple'
            },
            cyan: {
                bg: 'bg-cyan-lightest',
                color: 'color-cyan-dark'
            },
            green: {
                bg: 'bg-green-lighter',
                color: 'color-success'
            },
            red: {
                bg: 'bg-red-lighter',
                color: 'color-red'
            },
            default: {
                bg: 'bg-gray-lightest',
                color: 'color-gray-600'
            }
        },
        ['fill']: {
            // TODO: configurations for fill badges
        }
    };
    const classes = Object.values(types[props.variant]?.[props.color]);

    if (props.pill) {
        classes.push('badge-pill');
    }

    return classes;
});

return { __sfc: true,props, slots, typeClasses }
}

})